module.exports = __webpack_public_path__ + "media/images/amenities_icons/car_share-ed8756b1420577a31e5cd71821bddf85.svg";